(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const shell = document.querySelector('[data-cart-drawer]');
    if (!shell || shell.dataset.bound) return;
    shell.dataset.bound = 'true';

    const mount = shell.querySelector('[data-cart-mount]');
    const spinner = '<div class="cdrawer__spinner" aria-hidden="true"></div>';
    const root = () => window.Shopify?.routes?.root || '/';
    const onCartPage = document.body.classList.contains('template-cart');
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    let closeTimer = null;

    const setCount = (value) => {
      document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
        el.textContent = value;
      });
    };

    // One retry, then stop. 429 is the storefront throttling a burst and 5xx is
    // it having a moment; both clear often enough to be worth 700ms. Any other
    // 4xx is an answer, not a hiccup, and retrying it only wastes the visitor's
    // time. A network error is retried once and then reported as one.
    // Only reads are retried. An add or a remove may already have been applied
    // even when its answer never arrives, so replaying it could add twice or
    // remove the wrong line. Writes go once; the drawer then re-reads the cart.
    async function send(url, options) {
      let response = null;
      const method = ((options && options.method) || 'GET').toUpperCase();
      const tries = method === 'GET' ? 2 : 1;
      for (let attempt = 0; attempt < tries; attempt += 1) {
        try {
          response = await fetch(url, options);
          if (response.ok) return response;
          if (response.status !== 429 && response.status < 500) return response;
        } catch (error) {
          response = null;
        }
        if (attempt < tries - 1) await wait(700);
      }
      if (response) return response;
      throw new Error(shell.dataset.errorNetwork);
    }

    const paint = (html) => {
      const panel = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-cart-panel]');
      if (!panel) return false;
      mount.replaceChildren(panel);
      setCount(panel.dataset.cartCount);
      return true;
    };

    // The standalone render is the fallback now, for opening the drawer from the
    // header and for repainting after a failure. no-store because a cached copy
    // of this section is a cart from some earlier moment.
    async function refresh() {
      const response = await send(`${root()}?section_id=cart-drawer`, { cache: 'no-store' });
      paint(await response.text());
    }

    function clearError() {
      const existing = shell.querySelector('[data-cart-error]');
      if (existing) existing.remove();
    }

    function showError(message) {
      clearError();
      const note = document.createElement('p');
      note.className = 'cdrawer__error';
      note.setAttribute('data-cart-error', '');
      note.setAttribute('role', 'alert');
      note.textContent = message || shell.dataset.errorGeneric;
      shell.prepend(note);
    }

    function open() {
      clearTimeout(closeTimer);
      // Two stacked modal dialogs is one too many: the quick-view panel would
      // sit under the drawer, dimmed and unusable, until the drawer was closed.
      const quickView = document.querySelector('[data-quick-view-modal]');
      if (quickView && quickView.open) quickView.close();
      if (!shell.open) shell.showModal();
      requestAnimationFrame(() => shell.classList.add('is-open'));
    }

    function close() {
      shell.classList.remove('is-open');
      clearTimeout(closeTimer);
      // Guarded: an add that landed inside the 240ms slide-out used to be shut
      // again by the timer left over from the close before it.
      closeTimer = setTimeout(() => {
        if (!shell.classList.contains('is-open')) shell.close();
      }, 240);
    }

    // Escape closes the dialog without going through close(), so the class has
    // to be cleared here too or the next open starts already slid in.
    shell.addEventListener('close', () => {
      shell.classList.remove('is-open');
      clearError();
    });

    async function openWith(work) {
      clearError();
      mount.innerHTML = spinner;
      open();
      try {
        if (work) await work();
        else await refresh();
      } catch (error) {
        // Deliberately no redirect — see the note at the top of this file.
        try {
          await refresh();
        } catch (ignored) {
          mount.innerHTML = '';
        }
        showError(error && error.message);
      }
    }

    // ---------- add to cart ----------
    async function addToCart(form) {
      const body = new FormData(form);
      // Ask for the drawer in the same breath as the add, so the panel that
      // comes back is definitively the cart with this item in it.
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      const response = await send(`${root()}cart/add.js`, {
        method: 'POST',
        body,
        headers: { Accept: 'application/json' },
      });

      // A throttled storefront answers with an HTML page, not JSON, so the
      // parse has to be allowed to fail without becoming the error we report.
      let data = null;
      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }

      if (!response.ok) {
        throw new Error((data && (data.description || data.message)) || shell.dataset.errorNetwork);
      }

      const html = data && data.sections && data.sections['cart-drawer'];
      if (!html || !paint(html)) await refresh();
    }

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

      event.preventDefault();
      // A second press while the first is in flight used to add the item twice.
      if (form.dataset.busy) return;
      form.dataset.busy = 'true';

      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      openWith(() => addToCart(form)).finally(() => {
        delete form.dataset.busy;
        if (button) button.removeAttribute('aria-busy');
      });
    });

    // ---------- open from the header ----------
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener && !onCartPage) {
        event.preventDefault();
        openWith();
        return;
      }

      if (!shell.open) return;

      if (event.target.closest('[data-cart-close]')) {
        close();
        return;
      }

      // Backdrop: the dialog itself is the click target.
      if (event.target === shell) {
        close();
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        openWith(async () => {
          const response = await send(`${root()}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: remove.dataset.cartRemove,
              quantity: 0,
              sections: 'cart-drawer',
              sections_url: window.location.pathname,
            }),
          });

          let data = null;
          try {
            data = await response.json();
          } catch (error) {
            data = null;
          }

          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || shell.dataset.errorGeneric);
          }

          const html = data && data.sections && data.sections['cart-drawer'];
          if (!html || !paint(html)) await refresh();
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-compare-bar]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = 'true';

    const KEY = 'iac:compare:v1';
    const MAX = Number(bar.dataset.compareMax) || 4;
    const BASE = bar.dataset.compareUrl;
    const L = bar.dataset;

    const items = bar.querySelector('[data-compare-items]');
    const status = bar.querySelector('[data-compare-status]');
    const go = bar.querySelector('[data-compare-go]');
    const count = bar.querySelector('[data-compare-count]');

    // A corrupt or foreign value in this key must never take the page down, so
    // anything that does not parse into the expected shape is treated as empty.
    const read = () => {
      try {
        const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(raw)) return [];
        return raw.filter((i) => i && typeof i.h === 'string').slice(0, MAX);
      } catch (e) {
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {
        // Private mode, or the quota is full. The in-page state below still
        // works for this page view; only persistence is lost.
      }
      render();
    };

    const urlFor = (list) => `${BASE}?p=${list.map((i) => encodeURIComponent(i.h)).join(',')}`;

    let timer;
    const say = (message) => {
      status.textContent = message;
      clearTimeout(timer);
      timer = setTimeout(() => { status.textContent = ''; }, 4000);
    };

    // Two jobs, both measured rather than assumed. The page needs exactly as
    // much bottom padding as the tray is tall, or a white band appears under
    // the footer. And the theme editor's preview toolbar is fixed to the same
    // edge with a higher paint order, so on a preview URL the tray has to sit
    // above it. On a published storefront that element does not exist and the
    // lift is zero.
    let watching = false;
    const fit = () => {
      const toolbar = document.getElementById('PBarNextFrameWrapper');
      const lift = toolbar ? Math.round(toolbar.getBoundingClientRect().height) : 0;
      bar.style.bottom = lift ? `${lift}px` : '';
      document.body.style.paddingBottom = bar.hidden ? '' : `${bar.offsetHeight + lift}px`;

      if (toolbar && !watching && window.ResizeObserver) {
        watching = true;
        new ResizeObserver(fit).observe(toolbar);
      }
    };

    const render = () => {
      const list = read();
      const chosen = new Set(list.map((i) => i.h));

      document.querySelectorAll('[data-compare-handle]').forEach((el) => {
        const on = chosen.has(el.dataset.compareHandle);
        if (el.matches('input[type="checkbox"]')) {
          el.checked = on;
        } else {
          el.setAttribute('aria-pressed', String(on));
          const label = el.querySelector('[data-compare-label]');
          const text = on ? L.labelAdded : L.labelAdd;
          // Write only on change: the page observer below watches #main, and an
          // identical write still replaces the text node and re-triggers it.
          if (label && label.textContent !== text) label.textContent = text;
        }
      });

      bar.hidden = list.length === 0;
      document.body.classList.toggle('has-compare-bar', list.length > 0);

      count.textContent = String(list.length);
      go.href = urlFor(list);
      go.setAttribute('aria-disabled', String(list.length < 2));
      go.title = list.length < 2 ? L.labelMin : '';

      // Built node by node with textContent: product titles are merchant data
      // and never reach an innerHTML sink.
      items.replaceChildren(
        ...list.map((item) => {
          const li = document.createElement('li');
          li.className = 'cbar__item';

          if (item.i) {
            const img = document.createElement('img');
            img.className = 'cbar__thumb';
            img.src = item.i;
            img.alt = '';
            img.width = 34;
            img.height = 34;
            img.loading = 'lazy';
            li.append(img);
          }

          const name = document.createElement('span');
          name.className = 'cbar__name';
          name.textContent = item.t || item.h;
          li.append(name);

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'cbar__remove';
          remove.dataset.compareRemove = item.h;
          remove.setAttribute('aria-label', `${L.labelRemove} ${item.t || item.h}`);
          remove.textContent = '×';
          li.append(remove);

          return li;
        })
      );

      fit();
    };

    const add = (el) => {
      const list = read();
      const handle = el.dataset.compareHandle;
      if (list.some((i) => i.h === handle)) return true;
      if (list.length >= MAX) {
        say(L.labelFull);
        render();
        return false;
      }
      list.push({ h: handle, t: el.dataset.compareTitle || '', i: el.dataset.compareImage || '' });
      write(list);
      return true;
    };

    const remove = (handle) => write(read().filter((i) => i.h !== handle));

    document.addEventListener('change', (event) => {
      const box = event.target.closest('input[type="checkbox"][data-compare-handle]');
      if (!box) return;
      if (box.checked) add(box);
      else remove(box.dataset.compareHandle);
    });

    document.addEventListener('click', (event) => {
      const drop = event.target.closest('[data-compare-remove]');
      if (drop) {
        remove(drop.dataset.compareRemove);
        return;
      }

      if (event.target.closest('[data-compare-clear]')) {
        write([]);
        return;
      }

      const toggle = event.target.closest('button[data-compare-handle]');
      if (toggle) {
        const handle = toggle.dataset.compareHandle;
        if (read().some((i) => i.h === handle)) remove(handle);
        else add(toggle);
      }
    });

    // Another tab changed the selection.
    window.addEventListener('storage', (event) => {
      if (event.key === KEY) render();
    });

    window.addEventListener('resize', fit);

    // The preview toolbar is injected after the theme's own scripts run, so the
    // first measurement can miss it.
    setTimeout(fit, 1500);

    // Filtered grids swap the product list out from under us. Re-syncing the
    // new checkboxes is cheaper than making every grid know about compare.
    const main = document.getElementById('main');
    if (main) {
      let pending;
      new MutationObserver(() => {
        clearTimeout(pending);
        pending = setTimeout(render, 120);
      }).observe(main, { childList: true, subtree: true });
    }

    window.IACCompare = { key: KEY, max: MAX, read, write, remove, urlFor };
    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-engine"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-compare-table]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';

    const cfg = root.dataset;
    const rowsEl = document.querySelector('[data-cmp-rows]');
    if (!rowsEl) return;

    const ROWS = JSON.parse(rowsEl.textContent);
    const scroll = root.querySelector('[data-cmp-scroll]');
    const loading = root.querySelector('[data-cmp-loading]');
    const empty = root.querySelector('[data-cmp-empty]');
    const failed = root.querySelector('[data-cmp-error]');
    const tools = root.querySelector('[data-cmp-tools]');
    const diff = root.querySelector('[data-cmp-diff]');

    const store = window.IACCompare;
    const MAX = (store && store.max) || 4;

    // The URL wins over local storage. A link someone was sent describes a
    // specific comparison, and opening it should show that one, not whatever
    // this browser happened to have ticked.
    const wanted = () => {
      const p = new URLSearchParams(location.search).get('p');
      if (p) {
        return p.split(',').map((s) => decodeURIComponent(s.trim())).filter(Boolean).slice(0, MAX);
      }
      return store ? store.read().map((i) => i.h) : [];
    };

    const fetchOne = async (handle) => {
      try {
        const res = await fetch(`${cfg.productsRoot}${encodeURIComponent(handle)}?view=compare-data`);
        if (!res.ok) return null;
        return JSON.parse(await res.text());
      } catch (e) {
        return null;
      }
    };

    // BTU arrives as a real number so it can never be compared as text. Grouping
    // it for display is a rendering decision, made here rather than in Liquid.
    const cell = (value, isEmpty) => {
      const td = document.createElement('td');
      if (isEmpty) {
        td.className = 'is-empty';
        td.textContent = '—';
      } else {
        td.textContent = typeof value === 'number' ? value.toLocaleString() : value;
      }
      return td;
    };

    const valueOf = (p, key) => {
      if (key === 'price_label') return p.price_label;
      if (key === 'availability') return p.available ? cfg.labelInstock : cfg.labelOutstock;
      if (key === 'vendor') return p.vendor;
      if (key === 'sku') return p.sku;
      return p.specs ? p.specs[key] : null;
    };

    const buyCell = (p) => {
      const td = document.createElement('td');

      if (p.quote_only) {
        const a = document.createElement('a');
        a.className = 'button button--secondary';
        a.href = cfg.quoteUrl;
        a.textContent = cfg.labelQuote;
        td.append(a);
        return td;
      }

      if (!p.available) {
        const span = document.createElement('span');
        span.className = 'cstock--out';
        span.textContent = cfg.labelSoldout;
        td.append(span);
        return td;
      }

      // More than one variant means nothing has been chosen yet — a bundle with
      // an optional heat kit is exactly this case, so it goes to the product
      // page rather than quietly adding the wrong configuration.
      if (!p.buyable) {
        const a = document.createElement('a');
        a.className = 'button button--secondary';
        a.href = p.url;
        a.textContent = cfg.labelOptions;
        td.append(a);
        return td;
      }

      const form = document.createElement('form');
      form.action = cfg.cartAdd;
      form.method = 'post';
      form.enctype = 'multipart/form-data';

      const id = document.createElement('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = String(p.variant_id);

      const qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';

      const button = document.createElement('button');
      button.type = 'submit';
      button.className = 'button button--primary';
      button.textContent = cfg.labelBuy;

      form.append(id, qty, button);
      td.append(form);
      return td;
    };

    const addRow = (tbody, label, values, cells, extraClass) => {
      const tr = document.createElement('tr');
      if (extraClass) tr.className = extraClass;

      // Identical across every column: still shown, but muted, and hidden
      // outright when the buyer asks for differences only.
      if (values && new Set(values).size === 1) tr.classList.add('is-same');

      const th = document.createElement('th');
      th.scope = 'row';
      th.textContent = label;
      tr.append(th);
      cells.forEach((c) => tr.append(c));
      tbody.append(tr);
    };

    const build = (products) => {
      const table = document.createElement('table');
      table.className = 'cmptable';

      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      const corner = document.createElement('th');
      corner.scope = 'col';
      corner.textContent = ROWS.productLabel;
      headRow.append(corner);

      products.forEach((p) => {
        const th = document.createElement('th');
        th.scope = 'col';

        const box = document.createElement('div');
        box.className = 'ccol';

        if (p.image) {
          const img = document.createElement('img');
          img.className = 'ccol__img';
          img.src = p.image;
          img.alt = '';
          img.loading = 'lazy';
          box.append(img);
        }

        const link = document.createElement('a');
        link.className = 'ccol__title';
        link.href = p.url;
        link.textContent = p.title;
        box.append(link);

        const drop = document.createElement('button');
        drop.type = 'button';
        drop.className = 'ccol__drop';
        drop.dataset.cmpDrop = p.handle;
        drop.setAttribute('aria-label', `${cfg.labelRemove} ${p.title}`);
        drop.textContent = cfg.labelRemove;
        box.append(drop);

        th.append(box);
        headRow.append(th);
      });

      thead.append(headRow);
      table.append(thead);

      const tbody = document.createElement('tbody');

      ROWS.core.forEach((row) => {
        const values = products.map((p) => valueOf(p, row.key) || '');
        addRow(tbody, row.label, values, values.map((v) => cell(v, v === '')));
      });

      // A spec no product in this set publishes is not a blank row, it is a row
      // that should not exist. 56 source values were dropped in the migration
      // rather than guessed, so this is the common case, not the edge case.
      ROWS.specs.forEach((row) => {
        const values = products.map((p) => {
          const v = valueOf(p, row.key);
          return v === null || v === undefined ? '' : v;
        });
        if (values.every((v) => v === '')) return;
        addRow(tbody, row.label, values, values.map((v) => cell(v, v === '')));
      });

      addRow(tbody, ROWS.buyLabel, null, products.map(buyCell), 'cmptable__buy');

      table.append(tbody);
      return table;
    };

    const show = (el, on) => { if (el) el.hidden = !on; };

    const render = async () => {
      const list = wanted();

      show(loading, true);
      show(empty, false);
      show(failed, false);
      show(scroll, false);
      show(tools, false);

      if (!list.length) {
        show(loading, false);
        show(empty, true);
        return;
      }

      const products = (await Promise.all(list.map(fetchOne))).filter(Boolean);
      show(loading, false);

      if (!products.length) {
        show(failed, true);
        return;
      }

      // Adopt whatever actually resolved, so the tray, the ticked boxes and the
      // address bar all agree with the table on screen.
      if (store) {
        store.write(products.map((p) => ({ h: p.handle, t: p.title, i: p.image || '' })));
      }
      const query = products.map((p) => encodeURIComponent(p.handle)).join(',');
      history.replaceState({}, '', `${location.pathname}?p=${query}`);

      scroll.replaceChildren(build(products));
      show(scroll, true);
      show(tools, true);
    };

    root.addEventListener('click', (event) => {
      const drop = event.target.closest('[data-cmp-drop]');
      if (drop) {
        if (store) store.write(store.read().filter((i) => i.h !== drop.dataset.cmpDrop));
        const left = wanted().filter((h) => h !== drop.dataset.cmpDrop);
        history.replaceState({}, '', left.length ? `${location.pathname}?p=${left.join(',')}` : location.pathname);
        render();
        return;
      }

      if (event.target.closest('[data-compare-clear]')) {
        if (store) store.write([]);
        history.replaceState({}, '', location.pathname);
        render();
        return;
      }

      const shareButton = event.target.closest('[data-cmp-share]');
      if (shareButton) {
        navigator.clipboard?.writeText(location.href).then(() => {
          shareButton.textContent = cfg.labelCopied;
          setTimeout(() => { shareButton.textContent = cfg.labelShare; }, 2500);
        });
      }
    });

    if (diff) {
      diff.addEventListener('change', () => {
        root.classList.toggle('is-diff-only', diff.checked);
      });
    }

    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (() => {
    const container = document.querySelector('[data-facet-results]');
    if (!container || container.dataset.facetBound) return;
    container.dataset.facetBound = 'true';

    const sectionId = container.dataset.facetResults;
    let pending;
    let token = 0;

    async function apply(url, focusKey) {
      const mine = ++token;
      // The panel is re-rendered wholesale below, which would otherwise snap
      // the mobile card shut every time a box is ticked.
      const openBefore = container.querySelector('[data-facets-toggle]')?.checked;
      container.setAttribute('aria-busy', 'true');
      try {
        const join = url.includes('?') ? '&' : '?';
        const html = await fetch(`${url}${join}section_id=${sectionId}`).then((r) => r.text());
        if (mine !== token) return;
        const next = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-facet-results]');
        if (!next) {
          window.location.href = url;
          return;
        }
        container.replaceChildren(...next.childNodes);
        if (openBefore !== undefined) {
          const toggle = container.querySelector('[data-facets-toggle]');
          if (toggle) toggle.checked = openBefore;
        }
        window.history.pushState({ facets: true }, '', url);
        if (focusKey) container.querySelector(`[data-facet-key="${focusKey}"]`)?.focus();
      } catch (e) {
        window.location.href = url;
      } finally {
        if (mine === token) container.removeAttribute('aria-busy');
      }
    }

    // The filter form is the source of truth; the sort control contributes only
    // its own value. Building from both keeps a chosen sort order through a
    // filter change and vice versa.
    function buildUrl() {
      const form = container.querySelector('form.facets');
      if (!form) return null;
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (String(value).trim() !== '') params.append(key, value);
      });
      const sort = container.querySelector('[name="sort_by"]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      const base = form.getAttribute('action') || window.location.pathname;
      const query = params.toString();
      return query ? `${base}?${query}` : base;
    }

    container.addEventListener('change', (event) => {
      const field = event.target;
      // The mobile show/hide switch filters nothing, so it must not refresh.
      if (field.matches('[data-facets-toggle]')) return;
      if (!field.closest('form.facets') && field.name !== 'sort_by') return;

      const url = buildUrl();
      if (!url) return;

      const key = field.name && field.value ? `${field.name}|${field.value}` : null;
      clearTimeout(pending);
      // Price inputs are typed into, so they get a beat to settle; a checkbox
      // fires the moment it is ticked.
      pending = setTimeout(() => apply(url, key), field.type === 'number' ? 450 : 0);
    });

    container.addEventListener('submit', (event) => {
      if (!event.target.closest('form.facets') && !event.target.querySelector('[name="sort_by"]')) return;
      event.preventDefault();
      const url = buildUrl();
      if (url) apply(url);
    });

    window.addEventListener('popstate', (event) => {
      if (event.state?.facets) window.location.reload();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-toc"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-cpage]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';

    const body = root.querySelector('[data-cpage-body]');
    if (!body) return;

    // "Last updated" belongs with the title, not adrift in the first inch of
    // the text. Lifted only when the body genuinely opens with one.
    const meta = root.querySelector('[data-cpage-meta]');
    if (meta) {
      const lead = [...body.querySelectorAll('p')].slice(0, 3)
        .find((p) => /^\s*last\s+updated/i.test(p.textContent));
      if (lead) {
        meta.textContent = lead.textContent.trim();
        meta.hidden = false;
        lead.hidden = true;
      }
    }

    const visible = (el) => el && el.offsetParent !== null && !el.hidden;

    // offsetParent is null for the duplicate title the stylesheet hides, which
    // is exactly the heading that should not appear in the contents.
    const collect = (sel) => [...body.querySelectorAll(sel)]
      .filter((h) => visible(h) && h.textContent.trim().length > 1);

    // Which tag carries the structure differs page by page: the policies use
    // h2 for their clauses, Returns & Exchanges came out of WordPress with h3
    // and no h2 at all. Follow whichever level actually has sections in it, so
    // every page ends up with the same rail instead of some pages silently
    // going without.
    let heads = collect('h2');
    let sub = false;
    if (heads.length < 3) {
      const subs = collect('h3');
      if (subs.length > heads.length) {
        heads = subs;
        sub = true;
      }
    }

    if (sub) root.classList.add('cpage--sub');

    // A separating rule above the first heading is only a separator if there is
    // something above it to separate from.
    if (heads.length) {
      let prev = heads[0].previousElementSibling;
      while (prev && !visible(prev)) prev = prev.previousElementSibling;
      if (!prev) heads[0].classList.add('is-first');
    }

    const rail = root.querySelector('[data-cpage-rail]');
    const tocNav = root.querySelector('[data-cpage-toc-nav]');
    const railLinks = root.querySelector('[data-cpage-rail-links]');
    const list = root.querySelector('[data-cpage-toc]');
    const mob = root.querySelector('[data-cpage-toc-mobile]');
    const mobList = root.querySelector('[data-cpage-toc-mobile-list]');
    if (!rail || !list) return;

    // Too little structure to navigate. The column still earns its place —
    // the related pages go in it — so the page keeps the same two-column
    // measure as every other one. Only a page with nothing to put there falls
    // back to the single centred column.
    if (heads.length < 3) {
      if (railLinks) {
        railLinks.hidden = false;
        rail.hidden = false;
        root.classList.add('cpage--rail-links');
      } else {
        root.classList.add('cpage--narrow');
      }
      return;
    }

    // A policy that numbers its own clauses must not be numbered again.
    const selfNumbered = heads.filter((h) => /^\s*\d+\s*[.)]/.test(h.textContent)).length;
    if (selfNumbered >= heads.length * 0.6) {
      list.classList.add('ctoc__list--plain');
      if (mobList) mobList.classList.add('ctoc__list--plain');
    }

    const used = new Set();
    const slug = (text) => {
      const base = text.toLowerCase().trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .slice(0, 60) || 'section';
      let out = base;
      let n = 2;
      while (used.has(out)) out = `${base}-${n++}`;
      used.add(out);
      return out;
    };

    const links = [];

    heads.forEach((h) => {
      if (!h.id) h.id = slug(h.textContent);

      const make = () => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim();
        li.append(a);
        return { li, a };
      };

      const d = make();
      list.append(d.li);
      links.push({ id: h.id, a: d.a });

      if (mobList) mobList.append(make().li);
    });

    if (tocNav) tocNav.hidden = false;
    rail.hidden = false;
    if (mob) mob.hidden = false;

    if (!('IntersectionObserver' in window)) return;

    const seen = new Map();
    const paint = () => {
      let current = null;
      for (const { id } of links) {
        if (seen.get(id)) { current = id; break; }
      }
      links.forEach(({ id, a }) => a.classList.toggle('is-current', id === current));
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => seen.set(e.target.id, e.isIntersecting));
      paint();
    }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });

    heads.forEach((h) => io.observe(h));

    if (mob) {
      mob.addEventListener('click', (event) => {
        if (event.target.closest('a')) mob.open = false;
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('product-gallery')) return;

    class ProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.frames = [...this.querySelectorAll('[data-frame]')];
        this.lightbox = this.querySelector('[data-lightbox]');
        this.lightboxFrames = [...this.querySelectorAll('[data-lightbox-frame]')];
        this.count = this.querySelector('[data-lightbox-count]');
        this.index = 0;

        this.addEventListener('click', (e) => this.onClick(e));
        this.lightbox?.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.show(this.index + 1);
          if (e.key === 'ArrowLeft') this.show(this.index - 1);
        });
      }

      onClick(event) {
        const t = event.target;
        // The compare control lives on the frame but is not part of the gallery.
        if (t.closest('[data-compare-handle]')) return;
        const zoom = t.closest('[data-zoom]');
        if (zoom) {
          this.show(Number(zoom.dataset.zoom));
          this.lightbox?.showModal();
          return;
        }
        if (t.closest('[data-lightbox-close]')) return this.lightbox.close();
        if (t.closest('[data-gallery-prev]') || t.closest('[data-lightbox-prev]')) return this.show(this.index - 1);
        if (t.closest('[data-gallery-next]') || t.closest('[data-lightbox-next]')) return this.show(this.index + 1);
        const goto = t.closest('[data-goto]');
        if (goto) return this.show(Number(goto.dataset.goto));
        if (this.lightbox?.open && t === this.lightbox) {
          // click on the dark backdrop area of the dialog itself
          this.lightbox.close();
        }
      }

      show(i) {
        const n = this.frames.length;
        if (!n) return;
        this.index = ((i % n) + n) % n;
        this.frames.forEach((f, k) => f.classList.toggle('is-active', k === this.index));
        this.lightboxFrames.forEach((f, k) => f.classList.toggle('is-active', k === this.index));
        this.querySelectorAll('[data-goto]').forEach((b) => {
          b.classList.toggle('is-active', Number(b.dataset.goto) === this.index);
        });
        if (this.count) this.count.textContent = `${this.index + 1} / ${n}`;
      }
    }

    customElements.define('product-gallery', ProductGallery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('product-tabs')) return;

    class ProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.panels = [...this.querySelectorAll('[data-tab]')];
        this.bar = this.querySelector('[data-tabs-bar]');
        if (!this.bar || this.panels.length < 2) return;

        this.tabs = this.panels.map((panel, i) => {
          const heading = panel.querySelector('.ptabs__heading');
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'ptabs__tab';
          tab.id = `${panel.id}-tab`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          tab.textContent = heading ? heading.textContent.trim() : `${i + 1}`;
          tab.addEventListener('click', () => this.show(i, true));
          this.bar.append(tab);

          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
          return tab;
        });

        this.bar.addEventListener('keydown', (event) => this.onKeydown(event));
        this.bar.hidden = false;
        this.classList.add('ptabs--live');

        this.show(this.fromHash(), false);

        // A link anywhere on the page can open a panel, and the back button
        // still works because the hash is what drives it.
        window.addEventListener('hashchange', () => {
          const index = this.fromHash();
          if (index > -1) this.show(index, false, true);
        });
      }

      fromHash() {
        const id = window.location.hash.slice(1);
        const found = this.panels.findIndex((p) => p.id === id);
        return found > -1 ? found : 0;
      }

      show(index, focus, scroll) {
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.hidden = !active;
          this.tabs[i].setAttribute('aria-selected', String(active));
          // Only the selected tab is in the tab order; the arrows move between
          // them, which is how a tablist is meant to behave.
          this.tabs[i].tabIndex = active ? 0 : -1;
        });
        this.current = index;
        if (focus) this.tabs[index].focus();
        if (scroll) this.panels[index].scrollIntoView({ block: 'nearest' });
      }

      onKeydown(event) {
        const keys = { ArrowLeft: -1, ArrowRight: 1 };
        if (event.key === 'Home') {
          event.preventDefault();
          return this.show(0, true);
        }
        if (event.key === 'End') {
          event.preventDefault();
          return this.show(this.tabs.length - 1, true);
        }
        const step = keys[event.key];
        if (!step) return;
        event.preventDefault();
        const n = this.tabs.length;
        this.show((this.current + step + n) % n, true);
      }
    }

    customElements.define('product-tabs', ProductTabs);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.querySelector('[data-quick-view-modal]');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = 'true';

    const body = modal.querySelector('[data-qv-body]');
    const spinner = '<div class="qv-modal__spinner" aria-hidden="true"></div>';

    document.addEventListener('click', async (event) => {
      const trigger = event.target.closest('[data-quick-view]');
      if (trigger) {
        event.preventDefault();
        body.innerHTML = spinner;
        modal.showModal();
        try {
          const url = window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}products/${trigger.dataset.quickView}?section_id=quick-view`
            : `/products/${trigger.dataset.quickView}?section_id=quick-view`;
          const html = await fetch(url).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const panel = doc.querySelector('[data-qv-panel]');
          if (panel) body.replaceChildren(panel);
          else modal.close();
        } catch (e) {
          modal.close();
        }
        return;
      }

      if (!modal.open) return;

      if (event.target.closest('[data-qv-close]')) {
        modal.close();
        return;
      }

      // Click on the backdrop: the dialog itself is the target, and the click
      // point falls outside the panel box.
      if (event.target === modal) {
        const box = modal.getBoundingClientRect();
        const inside =
          event.clientX >= box.left && event.clientX <= box.right
          && event.clientY >= box.top && event.clientY <= box.bottom;
        if (!inside) modal.close();
        return;
      }

      // ---------- inner gallery ----------
      const frames = [...modal.querySelectorAll('[data-qv-frame]')];
      if (!frames.length) return;

      const current = frames.findIndex((f) => f.classList.contains('is-active'));
      const show = (i) => {
        const n = frames.length;
        const target = ((i % n) + n) % n;
        frames.forEach((f, k) => f.classList.toggle('is-active', k === target));
        modal.querySelectorAll('[data-qv-thumb]').forEach((t) => {
          t.classList.toggle('is-active', Number(t.dataset.qvThumb) === target);
        });
      };

      if (event.target.closest('[data-qv-prev]')) show(current - 1);
      else if (event.target.closest('[data-qv-next]')) show(current + 1);
      else {
        const thumb = event.target.closest('[data-qv-thumb]');
        if (thumb) show(Number(thumb.dataset.qvThumb));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('variant-picker')) return;

    class VariantPicker extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        try {
          this.variants = JSON.parse(this.dataset.variants);
        } catch (e) {
          return;
        }

        this.form = this.closest('form');
        this.addEventListener('change', () => this.onChange());
      }

      onChange() {
        const chosen = [...this.querySelectorAll('.vpick__input:checked')].map((i) => i.value);
        const variant = this.variants.find(
          (v) => chosen.every((val, i) => v.options[i] === val)
        );

        // Legend echoes the current value for each option.
        this.querySelectorAll('[data-current]').forEach((el) => {
          el.textContent = chosen[Number(el.dataset.current)] ?? '';
        });

        // Mark sold-out combinations instead of hiding them.
        this.querySelectorAll('.vpick__input').forEach((input) => {
          const trial = [...chosen];
          trial[Number(input.dataset.index)] = input.value;
          const match = this.variants.find((v) => trial.every((val, i) => v.options[i] === val));
          input.nextElementSibling?.classList.toggle('vpick__label--gone', !match || !match.available);
        });

        if (!variant) return;

        const idField = this.form?.querySelector('input[name="id"]');
        if (idField) idField.value = variant.id;

        const price = document.querySelector('[data-variant-price]');
        if (price && variant.price != null) {
          price.textContent = this.money(variant.price);
        }

        const button = this.form?.querySelector('[data-add-button]');
        if (button) {
          button.disabled = !variant.available;
          const label = button.querySelector('[data-add-label]');
          if (label) {
            label.textContent = variant.available
              ? button.dataset.labelAdd
              : button.dataset.labelSoldOut;
          }
        }

        // The stock badge follows the selection too, or it contradicts the
        // button: a bundle whose heat kit is out of stock is "available" at
        // product level while the combination on screen cannot be bought.
        const stock = document.querySelector('[data-stock-badge]');
        if (stock) {
          const badge = document.createElement('span');
          badge.className = variant.available ? 'badge badge--success' : 'badge';
          badge.textContent = variant.available ? stock.dataset.labelIn : stock.dataset.labelOut;
          stock.replaceChildren(badge);
        }

        // Keep the URL shareable without reloading the page.
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      money(cents) {
        const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        });
        return format.format(cents / 100);
      }
    }

    customElements.define('variant-picker', VariantPicker);
  })();
  } catch(e) { console.error(e); }
})();

})();
